<app-material>
    <div class="header" header>
        <app-tabs [tabs]="tabs"
                  [material]="false">
        </app-tabs>
    </div>
    <ng-container body>
        <router-outlet></router-outlet>
    </ng-container>
</app-material>
